var exports = {
  "HS": "VoiceE2EEIndicator.module__indicatorBase___cGtETH",
  "QS": "VoiceE2EEIndicator.module__indicatorEncrypted___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorBase___cGtETH",
  "pP": "VoiceE2EEIndicator.module__indicatorBroken___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorBase___cGtETH",
  "Gm": "VoiceE2EEIndicator.module__indicatorP2p___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorEncrypted___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorBase___cGtETH",
  "RQ": "VoiceE2EEIndicator.module__indicatorP2pBroken___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorBroken___cGtETH" + " " + "VoiceE2EEIndicator.module__indicatorBase___cGtETH",
};

module.exports = exports;
